import { featureFlags } from 'client/stores/FeatureFlagsModule';

/**
 * This mixin provides $hasFeatureFlag function that can be used within any Vue component.
 *
 * Usage example:
 *  <div v-if="$hasFeatureFlag($featureFlags.newCoolFeature)">New Cool Stuff</div>
 */
export default {
  computed: {
    $featureFlags: () => featureFlags,
  },
  methods: {
    $hasFeatureFlag(flag) {
      return !!this.$store.getters['FeatureFlagsModule/betaFeatures'][flag];
    },
  },
};
